module.exports = __webpack_public_path__ + "img/cl_five_steps_4.e6704a24.png";